import React, { createContext, useContext } from 'react';

import { Children } from '../types';
import { Props } from './link';

type Context = {
    link: React.ComponentType<Props>;
};

const ComponentContext = createContext<Context>(undefined as never);
export const useConfig = () => useContext(ComponentContext);

export const Provider = ({
    children,
    link = ({ to, ...props }) => <a {...props} href={to} />,
}: Partial<Context> & Children) => <ComponentContext.Provider value={{ link }}>{children}</ComponentContext.Provider>;
